import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const sliders = document.querySelectorAll('.js-slider');

const init = () => {
    if (sliders.length > 0) {
        sliders.forEach((slider) => {
            const opts = {
                modules: [Navigation, Pagination],
                grabCursor: true,
                navigation: {
                    nextEl: slider.querySelector('.swiper-button-next'),
                    prevEl: slider.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: slider.querySelector('.swiper-pagination'),
                    clickable: true,
                    bulletActiveClass: '!opacity-100',
                    renderBullet: (index, className) => `<span class="${className} w-8 h-0.5 bg-white opacity-20 pointer-events-auto"></span>`,
                },
                slidesPerView: 'auto',
                spaceBetween: (slider.dataset.spaceBetween
                    ? Number(slider.dataset.spaceBetween)
                    : 30),
            };

            if (undefined !== slider.dataset.loop) {
                opts.loop = true;
            }

            if (undefined !== slider.dataset.centeredSlides) {
                opts.centeredSlides = true;
            }

            const swiper = new Swiper(slider, opts); // eslint-disable-line no-unused-vars
        });
    }
};

export default init;
